import { sortBy } from 'lodash';
import { useEffect, useState } from 'react';
import { Button } from '@praktio/common-ui';

import { getLogs } from '../../utils/api';
import ActionBar from '../common/ActionBar';
import Table from '../common/Table/Table';

const LogTypes: { [key: string]: string } = {
  Courses: 'courses',
  Modules: 'modules',
  Teams: 'teams',
  Users: 'users',
};

const Logs = () => {
  const [logType, setLogType] = useState('');
  const [data, setData] = useState<any[] | undefined>();
  const [headers, setHeaders] = useState<any[]>([]);

  // If we get around to actually using this often, make a duck for it
  useEffect(() => {
    const fetchLogs = async () => {
      if (logType && logType !== '') {
        const response = await getLogs(logType);
        const data = response.data;
        const newHeaders: any[] = [];
        let updatedData = [];
        if (data?.length) {
          updatedData = sortBy(
            data.map((d: any) => ({
              ...(d.data || {}),
              id: d._id,
              dateLogged: d.updatedAt,
              loggedBy: d.updatedBy,
            })),
            'dateLogged',
          );

          updatedData.forEach((d: any) => {
            Object.keys(d).forEach((k) => {
              if (d[k] && typeof d[k] !== 'string') {
                d[k] = JSON.stringify(d[k]);
              }
            });
          });

          const record = updatedData[0];
          Object.keys(record).forEach((k) => {
            newHeaders.push({ Header: k, accessor: k });
          });
        }

        setHeaders(newHeaders);
        setData(updatedData);
      }
    };

    fetchLogs();
  }, [logType]);

  return (
    <div className="Logs">
      <ActionBar>
        {Object.keys(LogTypes).map((k) => {
          return (
            <Button onClick={() => setLogType(LogTypes[k])} key={k}>
              {k}
            </Button>
          );
        })}
      </ActionBar>
      <Table columns={headers} data={data || []} />
    </div>
  );
};

export default Logs;
